import { createBrowserRouter, Outlet, redirect } from 'react-router-dom';
import AllLocations from './components/all-locations';
import CampaignDetails from './components/campaign/details';
import ProtectedRoute from './components/proteted-route';
import SectionHeader from './components/ui/section-header';
import Home from './pages/home/home';
import Login from './pages/login/login';
import MyRewardsHub from './pages/my-rewards-hub';
import ActiveCampaigns from './pages/my-rewards-hub/campaigns';
import { BrandLocations } from './pages/my-rewards-hub/locations/BrandLocations';
import RewardTierDetails from './pages/my-rewards-hub/reward-tier-details';
import MyBrandRewards from './pages/my-rewards-hub/rewards';
import NotificationsPage from './pages/notifications';
import Referral from './pages/referral';
import ReferralLink from './pages/referral/ReferralLink';
import FailedScreen from './pages/register/FailedScreen/FailedScreen';
import PaymentFailedScreen from './pages/register/FailedScreen/PaymentFailedScreen';
import Register from './pages/register/Landing/register';
import RegisterScreen from './pages/register/RegisterScreen/RegisterScreen';
import RegistrationScreenSuccess from './pages/register/RegistrationScreenSuccess/RegistrationScreenSuccess';
import ResultScreen from './pages/register/result/ResultScreen';
import SessionEntryPage from './pages/session/SessionEntryPage';
import PinLimitPage from './pages/settings/pin-limit';
import Settings from './pages/settings/settings';
import TiersBenefits from './pages/tiers';
import TiersHistory from './pages/tiers/tiers-history';
import TiersLayout from './pages/tiers/tiers-layout';
import TransactionDetailsPage from './pages/transactions/TransactionDetailsPage';
import Layout from './shared/Layout';

export const router = createBrowserRouter(
  [
    {
      // Shared referral link component
      path: '/referral',
      element: <ReferralLink />
    },
    {
      path: '/',
      element: (
        <ProtectedRoute>
          <Layout />
        </ProtectedRoute>
      ),
      children: [
        {
          path: '/:token?',
          children: [
            {
              index: true,
              element: <Home />
            }
          ]
        },
        {
          path: '/all-locations',
          element: <AllLocations />
        },
        {
          path: '/my-rewards-hub',
          element: <MyRewardsHub />
        },
        {
          path: '/my-rewards-hub/:id',
          children: [
            {
              index: true,
              element: <RewardTierDetails />
            },
            {
              path: 'rewards',
              element: <MyBrandRewards />
            },
            {
              path: 'campaigns',
              element: (
                <div className="flex flex-col gap-y-4">
                  <SectionHeader
                    title={
                      <h1 className="text-lg font-bold leading-6 text-gray-900">
                        Active Campaigns
                      </h1>
                    }
                  />
                  <Outlet />
                </div>
              ),
              children: [
                { index: true, element: <ActiveCampaigns /> },
                {
                  path: ':campaignId',
                  element: <CampaignDetails />
                }
              ]
            }
          ]
        },
        {
          path: 'my-rewards-hub/:id/locations',
          element: <BrandLocations />
        },
        {
          path: '/my-rewards-hub/:id/tiers/*',
          async loader({ params, request, ...data }) {
            const paths = ['benefits', 'history'];
            const currentPath =
              new URL(request.url).pathname.split('/').pop() ?? 'benefits';
            console.log(currentPath, params);
            if (paths.indexOf(currentPath) === -1) {
              return redirect(`/my-rewards-hub/${params.id}/tiers/benefits`);
            }
            console.log(
              'Current path: ',
              currentPath,
              data,
              'Path Index',
              paths.indexOf(currentPath)
            );
            // return path index
            return paths.indexOf(currentPath);
          },
          element: <TiersLayout />,
          children: [
            { path: 'benefits', element: <TiersBenefits /> },
            { path: 'history', element: <TiersHistory /> }
          ]
        },
        {
          path: '/tiers/*',
          async loader({ request }) {
            const paths = ['benefits', 'history'];
            const currentPath =
              new URL(request.url).pathname.split('/').pop() ?? 'benefits';
            console.log(currentPath);
            if (currentPath && paths.indexOf(currentPath) === -1) {
              return redirect('/tiers/benefits');
            }

            // return path index
            return paths.indexOf(currentPath);
          },
          element: <TiersLayout />,
          children: [
            { path: 'benefits', element: <TiersBenefits /> },
            { path: 'history', element: <TiersHistory /> }
          ]
        },
        {
          path: '/settings',
          element: <Settings />
        },
        {
          path: '/settings/pin-limit',
          element: <PinLimitPage />
        },
        {
          path: '/referral-program',
          element: <Referral />
        },
        {
          path: '/notifications',
          element: <NotificationsPage />
        },
        {
          path: '/transactions/:transactionId',
          element: <TransactionDetailsPage />
        }
        // {
        //   path: '/old-home',
        //   element: <OldHome />,
        // },
      ]
    },
    {
      path: '/login',
      element: <Login />
    },
    {
      path: '/session',
      element: <SessionEntryPage />
    },
    {
      path: '/register',
      element: <Register />
    },
    {
      // Legacy redirect — /register/pin no longer exists
      path: '/register/pin',
      loader: () => redirect('/register')
    },
    {
      path: '/register/payment',
      element: <RegisterScreen />
    },
    {
      path: '/register/success',
      element: <RegistrationScreenSuccess />
    },
    {
      path: '/register/failed',
      element: <FailedScreen />
    },
    {
      path: '/register/payment-failed',
      element: <PaymentFailedScreen />
    },
    {
      path: '/register/result',
      element: <ResultScreen />
    }
  ],
  {
    basename: '/'
  }
);
